/** Auth entry intent: login vs first-time signup (persists across Auth0 redirect). */
export type AuthIntent = 'login' | 'signup'

export const AUTH_INTENT_STORAGE_KEY = 'swiftaidAuthIntent'

function readStoredIntent(): AuthIntent | null {
  try {
    const value =
      sessionStorage.getItem(AUTH_INTENT_STORAGE_KEY) ||
      localStorage.getItem(AUTH_INTENT_STORAGE_KEY)
    if (value === 'signup' || value === 'login') {
      return value
    }
  } catch {
    // ignore
  }
  return null
}

export function readAuthIntent(): AuthIntent {
  // Auth0 return URL is the most reliable signal after a redirect / magic link.
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('authintent')
    if (fromUrl === 'signup' || fromUrl === 'login') {
      writeAuthIntent(fromUrl)
      return fromUrl
    }
  } catch {
    // ignore
  }

  return readStoredIntent() ?? 'login'
}

export function writeAuthIntent(intent: AuthIntent): void {
  try {
    sessionStorage.setItem(AUTH_INTENT_STORAGE_KEY, intent)
    localStorage.setItem(AUTH_INTENT_STORAGE_KEY, intent)
  } catch {
    // ignore quota / private mode
  }
}

export function clearAuthIntent(): void {
  try {
    sessionStorage.removeItem(AUTH_INTENT_STORAGE_KEY)
    localStorage.removeItem(AUTH_INTENT_STORAGE_KEY)
  } catch {
    // ignore
  }
}
